module.exports = __webpack_public_path__ + "static/media/team4.67a25a5f.png";